<template>
  <v-card outlined class="pa-4" width="100%">
    <v-switch dense :disabled="disableAttachSwitch" data-testid="voicemails-settings-vmb-attach" v-model="attach"
      :label="$t('vmail.cfg.settings.attach')">
      <template v-slot:prepend>
        <v-icon>mdi-paperclip</v-icon>
      </template>
      <template v-slot:append>
        <cp-help i18n="vm.attach" />
      </template>
    </v-switch>
    <v-switch dense :disabled="disableDeleteVmAfterNotificationSwitch" data-testid="voicemails-settings-vmb-deletevm" v-model="deletevm"
      :label="$t('vmail.cfg.settings.delvm')">
      <template v-slot:prepend>
        <v-icon>mdi-delete</v-icon>
      </template>
      <template v-slot:append>
        <cp-help i18n="vm.delvm" />
      </template>
    </v-switch>
    <v-switch dense :disabled="!canWrite || hasMultipleActiveWatchers" data-testid="voicemails-settings-vmb-playcid" v-model="playcid"
      prepend-icon="mdi-card-account-phone"
      :label="$t('vmail.cfg.settings.playcid')"
    >
      <template v-slot:prepend>
        <v-icon>mdi-card-account-phone</v-icon>
      </template>
      <template v-slot:append>
        <cp-help i18n="vm.playcid" />
      </template>
    </v-switch>
    <v-switch dense :disabled="!canWrite || hasMultipleActiveWatchers" data-testid="voicemails-settings-vmb-envelope" v-model="envelope"
      :label="$t('vmail.cfg.settings.envelope')">
      <template v-slot:prepend>
        <v-icon>mdi-card-account-mail</v-icon>
      </template>
      <template v-slot:append>
        <cp-help i18n="vm.envelope" />
      </template>
    </v-switch>
    <v-switch dense :disabled="!canWrite || hasMultipleActiveWatchers" data-testid="voicemails-settings-vmb-skipInstruct" v-model="skipInstruct"
      :label="$t('vmail.cfg.settings.skipInstruct')">
      <template v-slot:prepend>
        <v-icon>mdi-volume-high</v-icon>
      </template>
      <template v-slot:append>
        <cp-help i18n="vm.skipInstruct" />
      </template>
    </v-switch>
  </v-card>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'voicemail-settings-general-voicemailbox',
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings',
      currentUserID: 'settings/userID',
      vmboxWriteFor: 'permissions/vmboxWriteFor',
      canWriteCurrentUser: 'permissions/vmboxesWrite',
      vmWatcherBoxID: 'voicemails/watcherBoxID',
      vmWatcherSubscriberID: 'voicemails/watcherSubscriberID',
      vmWatcherUserID: 'voicemails/watcherUserID',
      activeWatchers: 'voicemails/activeWatchers'
    }),
    canWrite: function () {
      if (this.activeWatchers.length > 1) {
        return false
      }
      if (this.currentUserID === this.vmWatcherUserID) {
        return this.canWriteCurrentUser
      }
      return this.vmboxWriteFor(this.vmWatcherSubscriberID)
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    },
    readyToEnableVmToEmail () {
      return this.vmbox.email !== '' || this.vmbox.pager !== ''
    },
    disableAttachSwitch: function () {
      return !this.canWrite || this.hasMultipleActiveWatchers || !this.readyToEnableVmToEmail
    },
    disableDeleteVmAfterNotificationSwitch: function () {
      return !this.canWrite || this.hasMultipleActiveWatchers || !this.readyToEnableVmToEmail || !this.attach
    },
    attach: {
      get: function () {
        return this.vmbox.attach
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.attach) {
          this.setAttach(value)
          this.save()
        }
      }
    },
    deletevm: {
      get: function () {
        return this.vmbox.deletevm
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.deletevm) {
          this.setDeleteVM(value)
          this.save()
        }
      }
    },
    playcid: {
      get: function () {
        return this.vmbox.playcid
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.playcid) {
          this.setPlayCID(value)
          this.save()
        }
      }
    },
    envelope: {
      get: function () {
        return this.vmbox.envelope
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.envelope) {
          this.setEnvelope(value)
          this.save()
        }
      }
    },
    skipInstruct: {
      get: function () {
        return this.vmbox.skipInstruct
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.skipInstruct) {
          this.setSkipInstruct(value)
          this.save()
        }
      }
    }
  },
  watch: {
    'vmbox.attach': {
      handler (newVal) {
        if (!newVal) {
          this.deletevm = false
        }
      },
      deep: true
    },
    'vmbox.email': {
      handler (newVal) {
        if (newVal === '') {
          this.attach = false
        }
      },
      deep: true
    },
    'vmbox.pager': {
      handler (newVal) {
        if (newVal === '') {
          this.attach = false
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setAttach: 'voicemails/setVBAttach',
      setDeleteVM: 'voicemails/setVBDeleteVM',
      setPlayCID: 'voicemails/setVBPlayCID',
      setEnvelope: 'voicemails/setVBEnvelope',
      setSkipInstruct: 'voicemails/setVBSkipInstruct',
      save: 'voicemails/saveSettings'
    })
  }
}
</script>

<style scoped>
</style>
